import TextField from "@material-ui/core/TextField";
import React from "react";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { Controller } from "react-hook-form";

export default function AutocompleteController({
  onChange,
  control,
  ...props
}) {
  return (
    <Controller
      as={
        <Autocomplete
          multiple={props.multiple}
          options={props.Values}
          groupBy={props.groupByFunc}
          getOptionLabel={(option) => (option.label ? option.label : option)}
          getOptionSelected={(option, value) =>
            value && option.value === value.value
          }
          //filterSelectedOptions={true}
          id={props.id}
          autoSelect={false}
          name={props.name}
          autoHighlight={false}
          error={props.error}
          required={props.required}
          disabled={props.disabled}
          onClose={() => {}}
          renderInput={(params) => (
            <TextField
              {...params}
              label={props.label}
              error={props.error}
              required={props.required}
              name={props.name}
              disabled={props.disabled}
              margin="normal"
              variant="outlined"
              size="small"
            />
          )}
        />
      }
      onChange={([,value, method]) => {
        
        try {
          if (method !== "blur"){
            props.getValueChanged(value);
          }
          
        } catch {
          //console.log("getvalueChnaged is not defined");
        }

        return value;
      }}
      name={props.name}
      rules={props.rules}
      control={control}
      defaultValue={props.defaultValue ? props.defaultValue : null}
    />
  );
}
